if (!customElements.get('details-overlay-modal')) {
  customElements.define('details-overlay-modal', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.hidden = true;
      this.onClick = event => {
        const trigger = event.target.closest('[aria-controls="dT_top-sticky"]');
        if (trigger) {
          event.preventDefault();
          this.opener = trigger;
          this.hidden = false;
          this.classList.add('search-show');
          document.body.classList.add('search-overlay-open');
          this.toggleTriggers(true);
          trapFocus(this.querySelector('.nt-search-panel'), this.querySelector('input[type="search"]'));
        } else if (this.contains(event.target) && event.target.closest('[data-search-dismiss]')) {
          this.close();
        }
      };
      this.onKeydown = event => {
        if (!this.hidden && event.key === 'Escape') {
          event.preventDefault();
          this.close();
        }
      };
      document.addEventListener('click', this.onClick);
      document.addEventListener('keydown', this.onKeydown);
    }

    toggleTriggers(open) {
      document.querySelectorAll('button[aria-controls="dT_top-sticky"]').forEach(button => button.setAttribute('aria-expanded', String(open)));
    }

    close() {
      this.querySelector('predictive-search')?.close();
      this.hidden = true;
      this.classList.remove('search-show');
      document.body.classList.remove('search-overlay-open');
      this.toggleTriggers(false);
      removeTrapFocus(this.opener);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onClick);
      document.removeEventListener('keydown', this.onKeydown);
      if (!this.hidden) this.close();
    }
  });
}
